export enum ReservedWords {
  TR_QI_LISTING = "sorular",
  EN_QI_LISTING = "questions",
  TR_QI_DETAIL = "soru-cozum",
  EN_QI_DETAIL = "questions-and-answers",
  TR_CONTENT_EXAM = "sinavlar",
  TR_CONTENT_COURSE = "dersler",
  TR_CONTENT_GRADE = "siniflar",
  TR_CONTENT_PATH_DETAIL = "hazirlik",
  TR_CONTENT_MODULE = "konular",
  TR_CONTENT_CONCEPT = "konular",
  TR_CONTENT_MATERIAL = "konular",
}
